import React from 'react';
import Modal, { ModalPrimaryButton, ModalSecondaryButton } from './Modal';

const LeaveProtectionModal = ({ blocker, onSaveAndLeave }) => {
  // Only show if the navigation is blocked
  if (!blocker || blocker.state !== 'blocked') return null;

  const handleLeave = () => {
    blocker.proceed();
  };

  const handleStay = () => {
    blocker.reset();
  };

  const handleSaveAndLeave = async () => {
      if (onSaveAndLeave) {
          await onSaveAndLeave();
      }
      blocker.proceed();
  };

  return (
    <Modal
      isOpen
      onClose={handleStay}
      title="Unsaved changes"
      icon="fa-triangle-exclamation"
      tone="warning"
      size="md"
      // Dismissing by accident is exactly what this dialog guards against.
      closeOnBackdrop={false}
      footer={
        <>
          <ModalSecondaryButton onClick={handleStay}>
            Stay on page
          </ModalSecondaryButton>
          <button
            type="button"
            onClick={handleLeave}
            className="sm:w-auto w-full px-5 py-2.5 rounded-lg border border-sunrise-red/30 text-sunrise-red text-sm font-semibold hover:bg-sunrise-red/5 transition-colors"
          >
            Leave without saving
          </button>
          <ModalPrimaryButton onClick={handleSaveAndLeave}>
            <i className="fas fa-check"></i>
            Save and leave
          </ModalPrimaryButton>
        </>
      }
    >
      <p className="text-sm text-slate-cloud">
        You have unsaved changes on this page. If you leave now they are lost.
      </p>
    </Modal>
  );
};

export default LeaveProtectionModal;
